import { BaseSettingsEndpoints } from './base';
import { Agenda } from '../types/agenda';

const AGENDA_BASE_PATH = '/v1/me/agenda';

export class AgendaClient extends BaseSettingsEndpoints {
  async getMyAgenda({
    from,
    tz,
    user_tz
  }: {
    from?: string;
    tz?: string;
    user_tz: string;
  }) {
    const params = new URLSearchParams();
    if (tz) {
      params.set('tz', tz);
    }
    params.set('user_tz', user_tz);
    if (from) {
      params.set('start', from);
    }
    return this.get<Agenda>(`${AGENDA_BASE_PATH}?${params.toString()}`);
  }

  async getUserAgenda({
    userId,
    from,
    tz,
    user_tz
  }: {
    userId: string;
    from?: string;
    tz?: string;
    user_tz: string;
  }) {
    const params = new URLSearchParams();
    if (tz) {
      params.set('tz', tz);
    }
    params.set('user_tz', user_tz);
    if (from) {
      params.set('start', from);
    }
    return this.get<Agenda>(`/v1/users/${userId}/agenda?${params.toString()}`);
  }
}
